import { ExtraOptions } from '@angular/router';

export const APP_ROUTER_OPTIONS: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  bindToComponentInputs: true,
  // With the default 'replace' the router rewrites the address bar to the last *successful* URL whenever a
  // navigation is cancelled. For the initial navigation that is the empty root, so a guard blocking the first
  // load (e.g. session check failing offline) silently moved the app to "/" and the next reload landed on the
  // login flow. 'computed' leaves the address bar alone in that case.
  canceledNavigationResolution: 'computed',
};
